export const voucherTemplate_saleDeliveryInfo = 'SaleDelivery'
export const voucherTemplate_saleOrderInfo = 'SaleOrder'

export const voucherTemplate_param_key = 'voucherTemplate_marketing_param_key'
export const localCache_prefix = 'voucherTemplate_marketing'
export const partnerVoucherTemplateNames = [voucherTemplate_saleDeliveryInfo,voucherTemplate_saleOrderInfo];
